import { render, staticRenderFns } from "./CmgOrderDiscounts.vue?vue&type=template&id=aa2708e2&scoped=true&lang=pug"
import script from "./cmg-order-discounts.ts?vue&type=script&lang=ts&external"
export * from "./cmg-order-discounts.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgOrderDiscounts.vue?vue&type=style&index=0&id=aa2708e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa2708e2",
  null
  
)

export default component.exports